import React, { useContext, useEffect, useState } from "react";
import { AuthDispatchContext } from '../App'
import { CloudURL, PrefixENV } from "../tools/Cloud";
import { domains, useDomainNavigate } from "../tools/Subdomain";
import { Badge, Button } from "reactstrap";
import { LayoutContext } from "../hocs/Layout"



export const SiteName = 'FairMarket.Land'

export const BGByDomain = (domain) => {
    // https://colorkit.co/background-maker/ff999a-53f489/

    const d = domain.toLowerCase()

    switch(d) {
        case "blender":
            return {useBG:true, bg:'bgs/colorkit_01.webp'}

        case "unreal":
            return {useBG:true, bg:'bgs/colorkit_04.webp'}

        case "godot":
            return {useBG:true, bg:'bgs/colorkit_07.webp'}

        case "indiegames":
            return {useBG:true, bg:'bgs/colorkit_00.webp'}

        case "houdini":
            return {useBG:true, bg:'bgs/colorkit_08.webp'}

        case "3dsmax":
            return {useBG:true, bg:'bgs/colorkit_05.webp'}
    
        case "maya":
            return {useBG:true, bg:'bgs/colorkit_06.webp'}

        case "books":
            return {useBG:true, bg:'bgs/colorkit_03.webp'}
    
        case "3dmodels":
            return {useBG:true, bg:'bgs/colorkit_09.webp'}

        case "fiberart":
            return {useBG:true, bg:'bgs/colorkit_10.webp'}
            
        default:
            return {useBG:false, bg:''}
    }
}



export const ButtonBG = ({label, padding='1.7em', fontSize='larger', open=false}) => {    
    const authDispatchContext = useContext(AuthDispatchContext)
    const layoutContext = useContext(LayoutContext)
    const navigate = useDomainNavigate()
    const url = label.toLowerCase().replace(/\s+/g, '')
    const backgroundImage = CloudURL(BGByDomain(url).bg)

    const buttonStyle = {
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.3)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        // width: '200px',
        // height: '50px',
        // Add any additional styles as needed
        padding: padding,
    }

    const buttonStyleClosed = {
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        // width: '200px',
        // height: '50px',
        // Add any additional styles as needed
        padding: padding,
        opacity: 0.65
    }

    const spanStyle = { letterSpacing: 2, fontSize: fontSize, fontWeight: '500' }
    const spanStyleClosed = { letterSpacing: 2, fontSize: 'small', fontWeight: '500' }

    const handleClosed = async(event) => {
        event.preventDefault()

        var buttons = <div>
            <Button color='primary' onClick={() => {authDispatchContext.navigateRedirect(navigate, '/login'); layoutContext.setForceCloseNotif(true)}}>Login</Button>
            &nbsp;
            <Button onClick={() => {authDispatchContext.navigateRedirect(navigate, '/signup'); layoutContext.setForceCloseNotif(true)}}>Sign Up</Button>
        </div>

        if (authDispatchContext.state.isAuthenticated) {
            buttons = <div>
                <Button color='primary' onClick={() => {authDispatchContext.navigateRedirect(navigate, '/store/productnew'); layoutContext.setForceCloseNotif(true)}}>New Product</Button>
            </div>
        }

        const text = <div>Be the first to add something new!{buttons}</div>

        layoutContext.setNotifContent({
            notimer:true,
            title:<>No products yet in {label}!</>,
            message:text
        })
    }

    return (
        <>
            {open && <Button color="light" block size="lg"
                onClick={() => navigate('', url)}
                style={buttonStyle}
                className='text-start'
            >
                <span style={spanStyle}>
                    {label}
                </span>
            </Button>}

            {!open && <Button color="light" block size="lg"
                onClick={handleClosed}
                style={buttonStyleClosed}
                className="d-flex align-items-center"
            >
                <span style={spanStyleClosed}>
                    {label}
                </span>
                <Badge style={{ marginLeft: "auto" }} pill color="info">Waiting for products!</Badge>
            </Button>}
        </>
    )
}



export const SiteSocialNetworks = () => {
    return (
        <span style={{fontSize:'larger'}}>
            <a href={`https://twitter.com/FairMarketLand`} rel="noreferrer" target="_blank" className="fa-brands fa-x-twitter"><i hidden="true">&nbsp;</i></a>
            {/* &nbsp;
            <a href={`https://www.facebook.com/fairmarketland`} rel="noreferrer" target="_blank" className="fa-brands fa-facebook-f"><i hidden="true">&nbsp;</i></a> */}
        </span>
    )
}



const SiteTitle = ({offCanvas=false, showTitle=true}) => {
    const authDispatchContext = useContext(AuthDispatchContext)
    const bgType = BGByDomain(authDispatchContext.domain)

    const [domain, setDomain] = useState('')

    const prefix = PrefixENV()

    
    useEffect(() => {
        if (domains.includes(authDispatchContext.domain)) {
            setDomain(authDispatchContext.domain.toUpperCase())
        }
        else {
            setDomain('')
        }

    }, [authDispatchContext.domain])


    // useEffect(() => {
    //     document.title = prefix + domain + ' ' + SiteName
    // // eslint-disable-next-line
    // }, [domain])

    const bg = {
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.3)), url(${CloudURL(bgType.bg)})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        // width: '200px',
        // height: '50px',
        // Add any additional styles as needed
        padding: '0.2em'
    }

    let styl = { letterSpacing: 2 }

    // if (offCanvas) {
    //     styl = { letterSpacing: 2, fontSize: '0.75em' }
    // }

    return (
        <span style={styl}>
            {false && prefix && <span className="alert-danger" style={{padding:'0.9em'}}>{prefix}</span>}
            <span style={bgType.useBG ? bg : {}}>{domain}</span>
            {/* {offCanvas && <br/>} */}
            {showTitle && <b style={{padding: '0.2em'}}>{SiteName}</b>}
            <img
                alt=''
                src={CloudURL('logo64.webp')}
                style={{verticalAlign:'text-bottom', height:'1.4em'}}
                className="mx-2"
            />
        </span>
    )
}

export default SiteTitle